module.exports = __webpack_public_path__ + "static/media/moeda-10.8d349a86.png";